<template>
  <!-- RQ "Consumer Details" card + its members list (detail page + data sheet page) -->
  <div>
    <div class="rqCard">
      <div class="flex items-center gap-1 pb-[15px]">
        <div class="w-[8px] h-[8px] rounded-full bg-[#A084E8]" />
        <div class="w-[35px] h-[8px] rounded-full bg-[#A084E8]" />
        <p class="text-[18px] laptop:text-[20px] font-semibold pl-2 m-0 text-[#333333]">Consumer Details</p>
      </div>
      <div class="flex items-center gap-[15px] pb-[15px] border-b-1 border-[#EFEFEF]">
        <img v-if="order.consumer?.profile_picture" :src="order.consumer.profile_picture" alt=""
          class="w-[50px] h-[50px] rounded-full object-cover flex-shrink-0">
        <span v-else class="w-[50px] h-[50px] rounded-full flex items-center justify-center flex-shrink-0 bg-[#EFEFEF]">
          <svg width="30" height="30" viewBox="0 0 16 16" aria-hidden="true">
            <path fill="#CCCCCC" d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-5 6a5 5 0 0 1 10 0z" />
          </svg>
        </span>
        <div class="min-w-0">
          <p class="m-0 text-[16px] largeDesktop:text-[18px] text-[#333333] break-words">{{ order.consumer?.full_name || '-' }}</p>
          <a v-if="order.consumer?.email" :href="'mailto:' + order.consumer.email"
            class="block text-[13px] text-[#666666] no-underline break-all">{{ order.consumer.email }}</a>
          <a v-if="order.consumer?.phone" :href="'tel:' + order.consumer.phone"
            class="block text-[13px] text-[#666666] no-underline">{{ order.consumer.phone }}</a>
        </div>
      </div>
      <div class="flex flex-wrap items-center gap-[10px] pt-[15px]">
        <button v-if="order.consumer?.consumer_id" type="button"
          class="group flex items-center gap-[6px] h-[36px] px-[15px] rounded-full border-1 border-[#00B7C2] bg-[#fff] text-[14px] text-[#00B7C2] hover:!bg-[#00B7C2] hover:text-white [@media(max-width:1023px)]:!bg-[#00B7C2] [@media(max-width:1023px)]:!text-white transition"
          @click="openMembers">
          View Members
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M4 12h16m0 0-6-6m6 6-6 6" class="stroke-[#00B7C2] group-hover:stroke-white [@media(max-width:1023px)]:!stroke-white" stroke="currentColor"
              stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </button>
        <!-- Call / Chat / SMS (Chat & SMS hidden after installation completed, like Android) -->
        <ChatChooser v-if="order.id" :size="36" :show-chat="Number(order.status) <= 8" :phone="order.consumer?.phone || ''"
          :order-id="order.id" :company-consumer-id="order.company_consumer_id || 0"
          :consumer-name="order.consumer?.full_name || ''" />
      </div>
    </div>

    <div ref="membersModal" class="modal fade" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered mobile:!w-full mobile:!right-0 mobile:!px-3 tablet:px-0 tablet:!w-[450px] !absolute tablet:!right-4 !top-0 !m-0 h-full">
        <div class="modal-content">
          <div class="modal-body !p-3 !pb-0 font-roboto flex flex-col">
            <FxModalHeader :title="members.length === 1 ? 'Member' : 'Members'" dismiss />
            <div class="flex-1 px-[6px]">
              <p v-if="!members.length" class="m-0 mt-[20px] text-center text-[13px] text-[#999999]">No members</p>
              <div v-for="m in members" :key="m.id"
                class="flex items-center justify-between gap-3 py-[10px] border-b-1 border-[#EFEFEF] text-[13px]">
                <span class="text-[#333333]">{{ m.full_name || m.name }} <span class="text-[#999999]">{{ m.relation }}</span></span>
                <a v-if="m.phone && m.is_allowed" :href="'tel:' + m.phone" class="text-[#7695FF] no-underline">{{ m.phone }}</a>
              </div>
            </div>
            <div class="uqcFooter flex items-center justify-end gap-[10px]">
              <button type="button" class="uqcBtnCancel" data-bs-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from "bootstrap";
import FxModalHeader from "../nest_components/FxModalHeader.vue";
import ChatChooser from "../chat/ChatChooser.vue";
import { rqApi } from "../../services/rqApi";
import { disableScroll, enableScroll } from "../../helpers/scrollHelper";

export default {
  components: { FxModalHeader, ChatChooser },
  props: {
    order: { type: Object, required: true },
  },
  data() {
    return { members: [] };
  },
  mounted() {
    this.$refs.membersModal.addEventListener("hidden.bs.modal", enableScroll);
  },
  beforeUnmount() {
    this.$refs.membersModal?.removeEventListener("hidden.bs.modal", enableScroll);
    this.bsModal?.hide();
  },
  methods: {
    async openMembers() {
      const res = await rqApi.members(this.order.consumer.consumer_id);
      this.members = res.ok && Array.isArray(res.body) ? res.body : [];
      this.bsModal = this.bsModal || new Modal(this.$refs.membersModal, { backdrop: "static", keyboard: false });
      disableScroll();
      this.bsModal.show();
    },
  },
};
</script>
